import React from 'react';

import { useSearchParams } from 'react-router-dom';

import { Box, Divider, Typography } from '@mui/material';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import useStyles from './styles';
import GeneralButton from '../../../../../Components/GeneralButton';

const FloorAutomationInfoMessage = () => {
	const classes = useStyles();

	const [searchParams, setSearchParams] = useSearchParams();

	const changeSetting = () => {
		setSearchParams({ tab: 'gamUprTabConfig' });
	};

	return (
		<>
			<Divider
				sx={{
					width: '95%',
					margin: '0 auto',
					mt: '3rem',
					mb: '2rem'
				}}
			/>

			<Box className={classes.floorAutomationContainer}>
				<Box className={classes.floorAutomationContent}>
					<Box className={classes.floorAutomationIcons}>
						<InfoOutlinedIcon className={classes.floorAutomationIcon} />

						<CheckCircleIcon className={classes.floorAutomationIcon} />
					</Box>

					<Box>
						<Typography className={classes.floorAutomationTitle}>
							Automated Floors Active
						</Typography>

						<Typography className={classes.floorAutomationDescription}>
							Floor prices are being optimized automatically. All configurations are managed by the
							automation system. To manually adjust settings, disable Automated Floors.
						</Typography>

						<GeneralButton
							name="gamUprConfigurationButton"
							variant="contained"
							endIcon={<ChevronRightIcon />}
							className={classes.floorAutomationButton}
							onClick={changeSetting}
						>
							Go to GAM UPR Configuration
						</GeneralButton>
					</Box>
				</Box>
			</Box>
		</>
	);
};

export default FloorAutomationInfoMessage;
